import React from 'react';
import EmailChipItem from './EmailChipItem';
import EmailChipItemGroup from './EmailChipItemGroup';

const EmailChipArea = (props) => {
    const { validEmails, invalidEmails, handleDelete } = props;
    let emails = [];
    let otherEmails = [];
    let errorEmails = [];
    let otherErrorEmails = [];
    if (validEmails.length > 3) {
        emails = validEmails.slice(0, 3);
        otherEmails = validEmails.slice(3, validEmails.length);
    } else {
        emails = validEmails;
    }
    if (invalidEmails.length > 3) {
        errorEmails = invalidEmails.slice(0, 3);
        otherErrorEmails = invalidEmails.slice(3, invalidEmails.length);
    } else {
        errorEmails = invalidEmails;
    }
    return (
        emails.length > 0 || otherEmails.length > 0 || errorEmails.length > 0 || otherErrorEmails.length > 0 ? (
            <div className="email-chip-wrapper">
                <div>
                    {(emails.length > 0) &&
                        emails.map(email => (
                            <EmailChipItem
                                handleDelete={handleDelete}
                                email={email}
                                valid={true}
                            />
                        ))}
                    {(otherEmails.length > 0) &&
                        <EmailChipItemGroup handleDelete={handleDelete} emails={otherEmails} valid={true} />}
                </div>
                <div>
                    {(errorEmails.length > 0) &&
                        errorEmails.map(email => (
                            <EmailChipItem
                                handleDelete={handleDelete}
                                email={email}
                                valid={false}
                            />
                        ))}
                    {(otherErrorEmails.length > 0) &&
                        <EmailChipItemGroup handleDelete={handleDelete} emails={otherErrorEmails} valid={false} />}
                </div>
            </div>
        ) : null
    );
};

export default EmailChipArea;
